import { render, staticRenderFns } from "./PointFormModal.vue?vue&type=template&id=09c01608&"
import script from "./PointFormModal.vue?vue&type=script&lang=js&"
export * from "./PointFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports